var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-flatpickr-component',_vm._g({staticClass:"vuestic-date-picker",class:{
    'has-value': _vm.valueProxy && _vm.valueProxy.length,
    disabled: _vm.disabled
  },attrs:{"config":_vm.fullConfig,"disabled":_vm.disabled},model:{value:(_vm.valueProxy),callback:function ($$v) {_vm.valueProxy=$$v},expression:"valueProxy"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }